define([
  'react',
  'underscore',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Drag',
], (React, _, Util, Drag) => {
  const { classNames } = Util;

  @Drag({ transform: false })
  class MoveHandle extends React.Component {
    static propTypes = {};

    render() {
      let {
        className,
        style,
        draggableEventHandlers,
        onMouseEnter,
        onMouseLeave,
      } = this.props;
      const handleClassName = classNames(
        `sumome-react-wysiwyg-move-handle`,
        className,
      );

      style.height = '100%';

      return (
        <div
          className={handleClassName}
          style={style}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          {...draggableEventHandlers}
        >
          {this.props.children}
        </div>
      );
    }
  }

  return MoveHandle;
});
